import { adminHttpClient } from '../commons/adminHttpClient'
import EmailTemplateStatus from '../../domain/mailHistory/EmailTemplateStatus'
import { NamedItemInt } from '../../domain/common/namedItem'

export type EmailTemplateResponse = {
  id: string
  subject: string
  status: EmailTemplateStatus
  product?: NamedItemInt
}

const getEmailTemplates = (): Promise<EmailTemplateResponse[]> => adminHttpClient.get('/EmailTemplates')

export default getEmailTemplates
